import {
  type AvailableLanguages,
  isTitle,
  type RatingEntity,
  type RatingPostBody,
  type RatingPutBody,
} from "~/src/api";
import type { TitleReviewForm } from "~/types/forms/titleReview";

export function getDefaultReviewForm(
  titleId: string,
  lang: AvailableLanguages = "en",
): TitleReviewForm {
  return {
    rating: 0,
    titleId: titleId,
    message: { [lang]: "" },
    language: lang,
  };
}

export function convertReviewToForm(review: RatingEntity): TitleReviewForm {
  return {
    reviewMeta: {
      id: review.id,
      version: review.attributes.version,
    },
    rating: review.attributes.rating,
    titleId: review.relationships.find(isTitle)?.id ?? "",
    message: review.attributes.message,
    language: review.attributes.originalLanguage,
  };
}

export function getRatingPostBody(form: TitleReviewForm): RatingPostBody {
  return {
    titleId: form.titleId,
    rating: form.rating,
    message: form.message,
  };
}

export function getRatingPutBody(form: TitleReviewForm): RatingPutBody {
  if (!form.reviewMeta)
    throw new Error("Cannot convert to put body, no rating meta available.");

  return {
    id: form.reviewMeta.id,
    version: form.reviewMeta.version,
    rating: form.rating,
    message: form.message,
  };
}
